module.exports = __webpack_public_path__ + "static/media/logo-header.572567f0.svg";